import { render } from "@react-email/render";
import { Email } from "components";
import { EmailData, IEmailData } from "data";
import { IEmail, IPotluck } from "interfaces";
import { Helpers, Routes } from "utils";

export interface IEmailService {
  forgotPassword(to: string, subject: string, id: string, name: string, role: string): Promise<void>;
  recoverAccount(to: string, subject: string, id: string, name: string, role: string): Promise<void>;
  invitation(to: string, subject: string, url: string, name: string, potluck: IPotluck): Promise<void>;
  newPotluck(to: string, subject: string, potluck: IPotluck): Promise<void>;
  results(to: string, subject: string, url: string, potluck: IPotluck): Promise<void>;
  newUser(to: string, subject: string, id: string, name: string, role: string): Promise<void>;
  voting(to: string, subject: string, url: string, potluck: IPotluck): Promise<void>;
  contributor(to: string, subject: string, id: string, potluckId: string, name: string, role: string): Promise<void>;
  passwordUpdated(to: string, subject: string, name: string, role: string): Promise<void>;
}

export class EmailService implements IEmailService {
  EmailData: IEmailData;

  constructor() {
    this.EmailData = new EmailData();
  }

  async forgotPassword(to: string, subject: string, id: string, name: string, role: string) {
    const html = await render(Email.ForgotPassword({ url: Helpers.generateForgotPasswordUrl({ id: id }), name: name }));
    this.EmailData.sendEmail({ to, subject, html } as IEmail);
  }

  async recoverAccount(to: string, subject: string, id: string, name: string, role: string) {
    const html = await render(Email.ForgotPassword({ url: Helpers.generateRecoverAccountUrl({ id: id }), name: name }));
    this.EmailData.sendEmail({ to, subject, html } as IEmail);
  }

  async invitation(to: string, subject: string, url: string, name: string, potluck: IPotluck) {
    const html = await render(Email.Invitation({ url: url, name: name, potluck }));
    this.EmailData.sendEmail({ to, subject, html } as IEmail);
  }

  async newPotluck(to: string, subject: string, potluck: IPotluck) {
    const html = await render(Email.Potluck({ url: Helpers.generateInterpolatedUrl(Routes.userdashboard), name: potluck.created_by.full_name, potluck }));
    this.EmailData.sendEmail({ to, subject, html } as IEmail);
  }

  async results(to: string, subject: string, url: string, potluck: IPotluck) {
    const html = await render(Email.Results({ url: url, name: potluck.created_by.first_name, potluck }));
    this.EmailData.sendEmail({ to, subject, html } as IEmail);
  }

  async newUser(to: string, subject: string, id: string, name: string, role: string) {
    const html = await render(Email.SignUp({ url: Helpers.generateInterpolatedUrl(Routes.createnew), name: name }));
    this.EmailData.sendEmail({ to, subject, html } as IEmail);
  }

  async voting(to: string, subject: string, url: string, potluck: IPotluck) {
    const html = await render(Email.Voting({ url: url, name: potluck.created_by.first_name, potluck }));
    this.EmailData.sendEmail({ to, subject, html } as IEmail);
  }

  async contributor(to: string, subject: string, id: string, potluckId: string, name: string, role: string) {
    // const html = await render(Email.Contributor({ url: Helpers.generateGuestUrl({ id: id }), name: name }));
    this.EmailData.sendEmail({ to, subject, html: "" } as IEmail);
  }

  async passwordUpdated(to: string, subject: string, name: string, role: string) {
    // const html = await render(Email.Contributor({ url: Helpers.generateGuestUrl({ id: id }), name: name }));
    this.EmailData.sendEmail({ to, subject, html: "" } as IEmail);
  }
}